import React, { Component } from 'react';
import { connect } from 'react-redux'
import Slider from 'react-slick'
import _ from 'lodash'
import { isAndroid } from 'react-device-detect';

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/backward.png' />
    )
}
function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/forward.png' />
    )
}

class TopCarouselComponent extends Component {

    onClick(type, id) {
        if (type == 'link') {
            window.open(id)
        }
        if (type == 'keyword' || type == 'product') {
            type == 'keyword' ? this.props.history.push(`/search/${id}`) : this.props.history.push(`/product/${id}`)
        }
        if (type == 'app') {
            if (isAndroid) {
                window.open('https://play.google.com/store/apps/details?id=com.plaping.songsodapp')
            } else {
                window.open('https://itunes.apple.com/th/app/%E0%B8%AA-%E0%B8%87%E0%B8%AA%E0%B8%94/id1374820727?mt=8')
            }
        }
    }

    render() {

        var setting = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 10000,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
        }

        var carousels = {
            //    "cn2": { "id": "https://dolfin.onelink.me/J4H9/97463994", "img_url": "https://songsod2019.sfo2.digitaloceanspaces.com/promotion_img/banner_jd.jpg", "type": "link" },
            // "cn1": { "id": "#", "img_url": "https://songsod2019.sfo2.digitaloceanspaces.com/carousel/songsod_j_cover_min.jpg", "type": "link" }, 
            "cn2": { "id": "#", "img_url": "../../static/images/top-carousel/CRcnf.jpg", "type": "link" },
        }


        var listSiteShow = []
        var id = 0

        _.map(carousels, carousel => {
            listSiteShow.push(<div key={id++}><img style={{ cursor: 'pointer' }} width={'100%'} height={'auto'} alt={carousel.id} src={carousel.img_url} onClick={() => { this.onClick(carousel.type, carousel.id) }} /></div>)
        })

        return (
            <Slider {...setting}>
                {listSiteShow}
            </Slider>
        )
    }
}

function mapStateToProps(state) {
    return {
        carouselstate: state.carouselstate
    }
}

export default connect(mapStateToProps)(TopCarouselComponent)



// WEBPACK FOOTER //
// ./src/components/top_carousel.js